import { render, staticRenderFns } from "./BulkDeleteModal.vue?vue&type=template&id=1f2d90de&"
import script from "./BulkDeleteModal.vue?vue&type=script&lang=js&"
export * from "./BulkDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f2d90de')) {
      api.createRecord('1f2d90de', component.options)
    } else {
      api.reload('1f2d90de', component.options)
    }
    module.hot.accept("./BulkDeleteModal.vue?vue&type=template&id=1f2d90de&", function () {
      api.rerender('1f2d90de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/whitelist/components/BulkDeleteModal.vue"
export default component.exports